import { Context, createContext } from 'react';
import { IOnePaymentItem, IPlan } from '../model';

export interface IAppContext {
  yearly: boolean;
  maxCurrent: number;
  totalPrice: number;
  selectedOneTimeItem?: IOnePaymentItem;
  oneTimeItem?: IOnePaymentItem;
  baseCheckoutPath: string;
  showRenewPopup: (data: {plan: IPlan} | null) => void;
}

const defaultValue: IAppContext = {
  yearly: false,
  maxCurrent: 0,
  totalPrice: 0,
  baseCheckoutPath: '',
  showRenewPopup: () => {}
}

export const AppContext: Context<IAppContext> = createContext(defaultValue);
